export default __webpack_public_path__ + "static/media/g20.png";